// extracted by mini-css-extract-plugin
module.exports = {"signature":"signature_signature__EerIo","tilde":"signature_tilde__RDdh3"};